module.exports = __webpack_public_path__ + "static/media/correios.4db32132.png";